<template>
  <b-modal
    id="modal-video-alert"
    :title="`${alert.vehicle.licensePlate} - ${
      language === 'en' ? alert.alert.descriptionEng : alert.alert.descriptionIdn
    }`"
    size="xl"
    centered
    :modal-class="`mc-modal-video ${
      !isFullScreen ? 'mc-modal-video--liveview' : 'mc-modal-video--liveview-full'
    }`"
    @show="onShowModal"
    @hidden="hideModalVideo"
  >
    <div class="mc-modal-video__Wrapper">
      <div class="mc-modal-video__top">
        <b-row>
          <b-col md="2">
            <div class="mc-modal-video__top-item">
              <span class="d-block text-muted">{{ $t('global.object.licensePlate') }}</span>
              <div>
                <strong>{{ alert.vehicle?.licensePlate ?? '-' }}</strong>
              </div>
            </div>
          </b-col>
          <b-col md="2">
            <div class="mc-modal-video__top-item">
              <span class="d-block text-muted">{{ $t('global.object.fleetCategory') }}</span>
              <strong>{{ vehicle.vehicleType?.category ?? '-' }}</strong>
            </div>
          </b-col>
          <b-col md="2">
            <div class="mc-modal-video__top-item">
              <span class="d-block text-muted">{{ $t('global.object.driver') }}</span>
              <strong>{{ alert.driver?.fullname ?? '-' }}</strong>
            </div>
          </b-col>
          <b-col md="2">
            <div class="mc-modal-video__top-item">
              <span class="d-block text-muted">{{ $t('global.object.phoneNumber') }} GPS</span>
              <strong>{{ vehicle.device?.phoneNo ?? '-' }}</strong>
            </div>
          </b-col>
          <b-col md="2">
            <div class="mc-modal-video__top-item">
              <span class="d-block text-muted">{{ $t('liveView.infoWindow.imei') }}</span>
              <strong>{{ vehicle.imei ?? '-' }}</strong>
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="mc-modal-video__content">
        <div
          class="mc-trackvideo-list__item-video-content-wrapper mc-trackvideo-list__item-video-content-open"
        >
          <div class="mc-trackvideo-list__item-video-content-open-source">
            <video-player
              v-if="getFormatVideo === 'mp4'"
              ref="videoInPlayerNotif"
              class="vjs-custom-skin"
              :options="playerInOptions"
              @ready="onInPlayerReady($event)"
              @error="onInPlayerError($event)"
              @waiting="onInPlayerWaiting($event)"
              @ended="onInPlayerEnded($event)"
            />
            <video-player-mux
              v-else-if="getFormatVideo === 'ts'"
              ref="videoInPlayerNotif"
              class="vjs-custom-skin"
              :src="url"
              :playerId="`videoPlayer${alert.vehicleId}`"
              @ready="onInPlayerReady($event)"
              @error="onInPlayerError($event)"
              @waiting="onInPlayerWaiting($event)"
              @loadeddata="onInPlayerLoadedData($event)"
              @ended="onInPlayerEnded($event)"
            />
          </div>
          <div class="d-flex justify-content-between mc-trackvideo-list__item-video-content-action">
            <div>
              <span>
                <i
                  v-if="!isPlay"
                  class="mc-fa icon-outline_play-circle"
                  @click="playInVideo(true)"
                ></i>
                <i
                  v-if="isPlay"
                  class="mc-fa icon-outline_pause-circle"
                  @click="playInVideo(false)"
                ></i>
              </span>
            </div>
            <div>
              <span>
                <i
                  v-if="!isMuted"
                  class="mc-fa icon-outline_volume-up"
                  @click="muteInVideo(true)"
                ></i>
                <i
                  v-if="isMuted"
                  class="mc-fa icon-outline_volume-off"
                  @click="muteInVideo(false)"
                ></i>
              </span>
              <i v-if="!isFullScreen" class="mc-fa icon-outline_expand" @click="fullScreen"></i>
              <i v-else class="mc-fa icon-outline_collapse" @click="closeFullscreen"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template #modal-footer="{ cancel }">
      <b-row class="mc-modal__filter-footer">
        <b-col sm="12" md="6" class="mc-modal__filter-footer-fav" />

        <b-col sm="12" md="6" class="mc-modal__filter-footer-btn">
          <b-button variant="outline-primary" class="me-3" @click="cancel()">
            {{ $t('global.action.close') }}
          </b-button>
          <McButton
            :text="loadingDownload ? $t('global.processing') : $t('global.action.download')"
            :icon="loadingDownload ? undefined : 'icon-outline_download'"
            :loading="loadingDownload"
            @click="handleClickDownloadVideo"
          />
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>
<script>
import { Helper } from '@/mixin/helper'
import VideoPlayer from '@/components/Video/VideoPlayer.vue'
import VideoPlayerMux from '@/components/Video/VideoPlayerMux.vue'
import i18n from '../../../../../i18n'
import { mapGetters } from 'vuex'
import McButton from '@/components/McButton'

export default {
  components: {
    VideoPlayer,
    VideoPlayerMux,
    McButton,
  },
  mixins: [Helper],
  props: {
    alert: {
      type: Object,
      default: () => {},
    },
    url: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      playerInOptions: {
        autoplay: true,
        controls: false,
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
        },
        sources: [
          {
            src: null,
            type: 'video/mp4',
          },
        ],
      },
      refsName: `videoInPlayerNotif`,
      isPlay: true,
      isMuted: false,
      isFullScreen: false,
      language: i18n.locale,
      loadingDownload: false,
    }
  },

  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
    getFormatVideo() {
      if (this?.url) {
        const arrUrl = this?.url.split('?')
        const arrFormat = arrUrl[0].split('.')
        const format = arrFormat[arrFormat.length - 1]
        return format.toLowerCase()
      } else {
        return 'mp4'
      }
    },
    vehicle() {
      const vehicle = this.alert.vehicle
      return vehicle
    },
  },

  methods: {
    hideModalVideo() {
      this.$bvModal.hide('modal-video-alert')
      this.$emit('close')
    },

    onShowModal() {
      this.isPlay = true
      this.isMuted = false
      this.playerInOptions.sources[0].src = this.url
    },

    onInPlayerReady() {
      this.$refs[this.refsName].player.play()
    },

    onInPlayerError(e) {
      // eslint-disable-next-line no-console
      console.log(e)
    },

    onInPlayerWaiting() {
      setTimeout(() => {
        this.$refs[this.refsName].player.pause()
      }, 20 * 1000)
    },

    onInPlayerEnded() {
      this.$refs[this.refsName].player.pause()
      this.isPlay = !this.isPlay
    },

    playInVideo(isPlay) {
      this.isPlay = !this.isPlay
      if (!isPlay) {
        this.$refs[this.refsName].player.pause()
        return
      }

      this.$refs[this.refsName].player.play()
    },

    muteInVideo(isMuted) {
      this.isMuted = !this.isMuted
      this.$refs[this.refsName].player.muted(isMuted)
    },

    fullScreen() {
      this.isFullScreen = true
      var elem = document.documentElement

      if (elem.requestFullscreen) {
        elem.requestFullscreen()
      } else if (elem.webkitRequestFullscreen) {
        /* Safari */
        elem.webkitRequestFullscreen()
      } else if (elem.msRequestFullscreen) {
        /* IE11 */
        elem.msRequestFullscreen()
      }
    },

    closeFullscreen() {
      this.isFullScreen = false
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.webkitExitFullscreen) {
        /* Safari */
        document.webkitExitFullscreen()
      } else if (document.msExitFullscreen) {
        /* IE11 */
        document.msExitFullscreen()
      }
    },
    handleClickDownloadVideo() {
      const hasScopeConvertVideo = this.hasAccess(['b3q-trackvision-convert-video-download:read'])
      if (hasScopeConvertVideo) {
        this.convertAndDownload()
      } else {
        this.directDownload()
      }
    },
    async convertAndDownload() {
      const path = this.extractPathFromDomain(this.url)
      this.loadingDownload = true
      try {
        const res = await fetch(process.env.VUE_APP_API_CONVERT_VIDEO + '/' + path, {
          method: 'GET',
        })
        if (!res.ok) throw new Error('Failed to fetch file')
        const blob = await res.blob()
        const downloadUrl = window.URL.createObjectURL(blob)
        const arr = path.split('/')
        let filename = arr[arr.length - 1] || 'video.mp4'
        const contentDisposition = res.headers.get('Content-Disposition')
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/)
          if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1]
          }
        }
        this.downloadFile(downloadUrl, filename)
      } catch (error) {
        console.error(error)
        this.$mcToast.error('Failed convert video')
      } finally {
        this.loadingDownload = false
      }
    },
    directDownload() {
      const arr = this.url.split('?')[0].split('/')
      const fileName = arr[arr.length - 1]
      this.downloadFile(this.url, fileName)
    },
  },
}
</script>
